import { render, staticRenderFns } from "./Photography.vue?vue&type=template&id=596ad816&scoped=true&"
import script from "./Photography.vue?vue&type=script&lang=js&"
export * from "./Photography.vue?vue&type=script&lang=js&"
import style0 from "./Photography.vue?vue&type=style&index=0&id=596ad816&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596ad816",
  null
  
)

export default component.exports